import { Component } from '@angular/core';
import { ProvidersIntroComponent } from './providers-intro/providers-intro.component';
import { ProvidersFaqComponent } from './providers-faq/providers-faq.component';
import { ProvidersApplicationComponent } from './providers-application/providers-application.component';

@Component({
  selector: 'app-providers',
  standalone: true,
  imports: [
    ProvidersIntroComponent,
    ProvidersFaqComponent,
    ProvidersApplicationComponent
  ],
  templateUrl: './providers.component.html',
  styleUrl: './providers.component.scss'
})
export class ProvidersComponent {

}
